// extracted by mini-css-extract-plugin
export var labelWrapper = "_gr-0";